"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountryIdFromWarehouseId = exports.DEFAULT_COUNTRY_ID = void 0;
exports.DEFAULT_COUNTRY_ID = "gb";
function getCountryIdFromWarehouseId(warehouseId, isThrowingError) {
    var countryId = warehouseId === null || warehouseId === void 0 ? void 0 : warehouseId.split("_")[0];
    if (!countryId) {
        if (isThrowingError) {
            throw Error("Can not get country from warehouse ID \"" + warehouseId + "\"");
        }
        countryId = exports.DEFAULT_COUNTRY_ID;
    }
    if (countryId === "uk")
        return "gb";
    return countryId;
}
exports.getCountryIdFromWarehouseId = getCountryIdFromWarehouseId;
